import React from "react";
import { useTranslation } from 'react-i18next';
import { CheckCircleIcon } from "@heroicons/react/24/solid";
import { ClockIcon } from "@heroicons/react/24/outline";

interface Props {
  paid: number;
  total: number;
}

const BillingTimeline: React.FC<Props> = ({ paid, total }) => {
  const { t } = useTranslation();
  const steps = [
    { label: t("Retainer Paid"), amount: 2500 },
    { label: t("Milestone Payment"), amount: 5000 },
  ];

  const progress = Math.min((paid / total) * 100, 100);

  return (
    <div className="mt-6">
      <h3 className="text-sm font-semibold text-gray-800 dark:text-gray-200 mb-3">
        {t('Billing Timeline')}
      </h3>

      <div className="relative w-full h-2 bg-gray-200 dark:bg-gray-700 rounded-full overflow-hidden">
        <div
          className="h-full bg-success-500 transition-all duration-700 ease-in-out"
          style={{ width: `${progress}%` }}
        />
      </div>

      <div className="flex justify-between mt-4 text-xs text-gray-600 dark:text-gray-400">
        {steps.map((step, index) => {
          const isCompleted = paid >= step.amount;
          return (
            <div key={index} className="flex flex-col items-center text-center w-1/2">
              {isCompleted ? (
                <CheckCircleIcon className="h-5 w-5 text-success-500 mb-1" />
              ) : (
                <ClockIcon className="h-5 w-5 text-gray-400 mb-1" />
              )}
              <span className={isCompleted ? "text-success-600 font-medium" : "text-gray-500"}>
                {step.label}
              </span>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default BillingTimeline;
